export default "__VITE_ASSET__DNXr31hx__"